import { PublicationType } from "src/core/backend/controllers";

export const DocumentTypes = {
  Amtsblatt: "pub_amtsblatt" as PublicationType,
  Abstimmungsbroschueren: "pub_abstimmungsbroschueren" as PublicationType,
  GVP: "pub_gvp" as PublicationType,
  GeschaeftsberichtRegierung: "pub_geschaeftsberichte_regierung" as PublicationType,
  Kantonsratsprotokolle: "pub_kantonsratsprotokolle" as PublicationType,
  Regierungsprotokolle: "pub_regierungsprotokolle" as PublicationType,
  Staatskalender: "pub_staatskalender" as PublicationType,
  Schulblatt: "pub_schulblatt" as PublicationType,
  Gesetzessammlung: "pub_gesetzessammlung" as PublicationType,
} as const;
